'use client';

import { useEffect } from 'react';
import { signIn } from 'next-auth/react';
import { useRouter, useSearchParams } from 'next/navigation';
import { useAuth } from './useAuth';

export function useAuthCheck() {
  const router = useRouter();
  const searchParams = useSearchParams();
  const { isLoggedIn } = useAuth();

  useEffect(() => {
    if (!isLoggedIn) {
      if (searchParams?.get('signup') === 'true') {
        try {
          const url = new URL('/auth/signup', process.env.NEXT_PUBLIC_SUBRITE_URL);
          url.searchParams.set(
            'callbackUrl',
            new URL(
              `/auth-check?${searchParams.toString()}`,
              process.env.NEXT_PUBLIC_NEXTAUTH_URL,
            ).toString(),
          );
          url.searchParams.set('reference', searchParams.get('reference') ?? '/');
          window.location.href = url.toString();
        } catch (error) {
          console.error(error);
        }
      } else {
        signIn('subrite', {
          callbackUrl: `/auth-check?${searchParams.toString()}`,
        });
      }
    } else {
      router.replace(searchParams.get('reference') ?? '/');
    }
  }, [isLoggedIn, searchParams, router]);
}
